module.exports = __webpack_public_path__ + "img/l-invite.876af8ea.jpg";